import React from 'react';

import { Col, Row } from '@shared/components/bootstrap';

import { FieldFormGroup, InputFormGroup, MultiselectFormControl } from '@admin/components/fields';
import { Selector as RegionSelector } from '@admin/components/regions/selector';
import { Availability__RescheduleOfferFiltersInput } from '@admin/schema';

import { CLASSIFICATION_OPTIONS } from '../util';

export const Filters: React.FC<{
  filters: Availability__RescheduleOfferFiltersInput;
  onChange(filters: Availability__RescheduleOfferFiltersInput): void;
}> = ({ filters, onChange }) => (
  <Row>
    <Col md={3}>
      <InputFormGroup
        id="from_date"
        label="From Date:"
        type="date"
        min="0000-01-01"
        max="9999-12-31"
        value={filters.fromDate || ''}
        onChange={(event) => onChange({ ...filters, fromDate: event.target.value || '' })}
      />
    </Col>
    <Col md={3}>
      <InputFormGroup
        id="till_date"
        label="Till Date:"
        type="date"
        min="0000-01-01"
        max="9999-12-31"
        value={filters.tillDate || ''}
        onChange={(event) => onChange({ ...filters, tillDate: event.target.value || '' })}
      />
    </Col>
    <Col md={3}>
      <FieldFormGroup label="Regions:">
        <RegionSelector selectedIDs={filters.regionIDs} onChange={(regionIDs) => onChange({ ...filters, regionIDs })} />
      </FieldFormGroup>
    </Col>
    <Col md={3}>
      <FieldFormGroup label="Order Classifications:">
        <MultiselectFormControl
          placeholder="Order Classifications"
          options={CLASSIFICATION_OPTIONS}
          selectedIDs={filters.orderClassifications}
          onChange={(orderClassifications) =>
            onChange({
              ...filters,
              orderClassifications,
            })
          }
        />
      </FieldFormGroup>
    </Col>
  </Row>
);
